module.exports = __webpack_public_path__ + "img/sword-air-02.cd6641a7.png";